import Vue from 'vue'
import VueRouter from 'vue-router'
import MainPage from '../../../components/MainPage'
import Login from '../../../components/Login'
import Register from '../../../components/Register'
import ForgotPassword from "../../../components/ForgotPassword";
import VerifyAccount from "../../../components/VerifyAccount";
import ResetPassword from "../../../components/ResetPassword";
import ContactUs from "../../../components/ContactUs";
import Contribute from "../../../components/Contribute";
import OfferFinishedHandSanitizer from "../../../components/forms/hand-sanitizer/OfferFinishedHandSanitizer";
import RequestFinishedHandSanitizer from "../../../components/forms/hand-sanitizer/RequestFinishedHandSanitizer";
import OfferMaterials from "../../../components/forms/OfferMaterials";
import RequestMaterials from "../../../components/forms/RequestMaterials";
import MyPosts from "../../../components/MyPosts";
import EndUserAgreement from "../../../components/EndUserAgreement";

Vue.use(VueRouter); //Tell it to use the router
const routes = [//Define the routes
    {path: '/', component: MainPage},
    {path: '/login', component: Login},
    {path: '/register', component: Register},
    {path: '/forgot-password', component: ForgotPassword},
    {path: '/offer-finished-handsanitizer',
        component: OfferFinishedHandSanitizer,
        props: (route) => ({
                            routedProductInfo: {productId:'', description: '', productType: '', requestId: '', totalDemand: ''},
                            ...route.params
                            }),
        name: 'offerFinishedProduct'},
    {path: '/request-finished-handsanitizer',
        component: RequestFinishedHandSanitizer,
        props: (route) => ({
            routedProductInfo: {productId:'', description: '', productType: '', requestId: '', totalDemand: ''},
            ...route.params
        }),
        name: 'requestFinishedProduct'},
    {path: '/offer-materials',
        component: OfferMaterials,
        props: (route) => ({
            routedMaterialInfo: {productType:'', productName:''},
            ...route.params
        }),
        name: 'offerMaterials'
    },
    {path: '/request-materials',
        component: RequestMaterials,
        props: (route) => ({
            routedMaterialInfo: {productType:'', productName:''},
            ...route.params
        }),
        name: 'requestMaterials'
    },
    {path: '/verify-account', component: VerifyAccount},
    {path: '/reset-password', component: ResetPassword},
    {path: '/contact-us', component: ContactUs},
    {path: '/contribute', component: Contribute},
    {path: '/end-user-agreement', component: EndUserAgreement},
    {path: '/my-posts',
        component: MyPosts,
        props: (route) => ({
            ...route.params
        }),
        name: 'myPosts'},
];

export const router = new VueRouter({//Define the router itself
    routes: routes,
    mode: 'hash'
});

router.beforeEach((to, from, next) => {//This will send them to the login page if they're not logged in and trying to access anything that isn't marked as a public page
    window.scrollTo(0, 0);// move to top of the page on route change

    const publicPages = [//Defines pages you don't need to be logged in to access
        '/',
        '/contact-us',
        '/contribute',
        '/login',
        '/register',
        '/forgot-password',
        '/verify-account',
        '/reset-password',
        '/end-user-agreement'];

    const authRequired = !publicPages.includes(to.path);//Sets whether authorization is required based on whether or not it's a public page
    const loggedIn = localStorage.getItem('accessToken');//Fetches whether or not they have logged in

    if (authRequired && !loggedIn) {//If login is required but they haven't yet
        localStorage.setItem('nextRoutePath', to.path);
        return next({
            path: '/login'
        });
    }

    next({to});
});
